__turbopack_context__.v({
  "card": "LandingPlanCard-module__7qzP6G__card",
  "checklist": "LandingPlanCard-module__7qzP6G__checklist",
  "checklistItem": "LandingPlanCard-module__7qzP6G__checklistItem",
  "checklistLabel": "LandingPlanCard-module__7qzP6G__checklistLabel",
  "chooseButton": "LandingPlanCard-module__7qzP6G__chooseButton",
  "compareArrowWrap": "LandingPlanCard-module__7qzP6G__compareArrowWrap",
  "compareDivider": "LandingPlanCard-module__7qzP6G__compareDivider",
  "compareFooter": "LandingPlanCard-module__7qzP6G__compareFooter",
  "compareLink": "LandingPlanCard-module__7qzP6G__compareLink",
  "description": "LandingPlanCard-module__7qzP6G__description",
  "glpIncludeBody": "LandingPlanCard-module__7qzP6G__glpIncludeBody",
  "glpIncludeDivider": "LandingPlanCard-module__7qzP6G__glpIncludeDivider",
  "glpIncludeItem": "LandingPlanCard-module__7qzP6G__glpIncludeItem",
  "glpIncludeTag": "LandingPlanCard-module__7qzP6G__glpIncludeTag",
  "glpIncludeTagQuantity": "LandingPlanCard-module__7qzP6G__glpIncludeTagQuantity",
  "glpIncludeTitle": "LandingPlanCard-module__7qzP6G__glpIncludeTitle",
  "glpIncludeTitleRow": "LandingPlanCard-module__7qzP6G__glpIncludeTitleRow",
  "glpIncludesClickArea": "LandingPlanCard-module__7qzP6G__glpIncludesClickArea",
  "glpIncludesList": "LandingPlanCard-module__7qzP6G__glpIncludesList",
  "glpPricingTierLabel": "LandingPlanCard-module__7qzP6G__glpPricingTierLabel",
  "headerBlock": "LandingPlanCard-module__7qzP6G__headerBlock",
  "iconWrapper": "LandingPlanCard-module__7qzP6G__iconWrapper",
  "includeThumbnail": "LandingPlanCard-module__7qzP6G__includeThumbnail",
  "includesBlock": "LandingPlanCard-module__7qzP6G__includesBlock",
  "includesHeader": "LandingPlanCard-module__7qzP6G__includesHeader",
  "includesWrapper": "LandingPlanCard-module__7qzP6G__includesWrapper",
  "journeyFooterLink": "LandingPlanCard-module__7qzP6G__journeyFooterLink",
  "originalPrice": "LandingPlanCard-module__7qzP6G__originalPrice",
  "planName": "LandingPlanCard-module__7qzP6G__planName",
  "planTag": "LandingPlanCard-module__7qzP6G__planTag",
  "price": "LandingPlanCard-module__7qzP6G__price",
  "priceGroup": "LandingPlanCard-module__7qzP6G__priceGroup",
  "priceRow": "LandingPlanCard-module__7qzP6G__priceRow",
  "titlePriceGroup": "LandingPlanCard-module__7qzP6G__titlePriceGroup",
  "titleRow": "LandingPlanCard-module__7qzP6G__titleRow",
});
